import * as React from 'react'
import { IMap, IProviderProductObject, IProviderServiceLevel } from '../../types'
import { isNotBlank } from '../../utils/validators'
import { FormComponent } from '../ui/Forms'
import ImageUpload from '../ui/ImageUpload'
import FloatingForm from '../ui/form/FloatingForm'
import { Input, Textarea, Select } from '@mobiscroll/react-latest'
import { withNotification } from '../ui/notification-provider'

interface ICreateProps {
  organizationId: string
  serviceLevels: IMap<IProviderServiceLevel>
  history: any
  onCreate: (product: IProviderProductObject) => any
  notification?: any
}

interface IControlsProps {
  product: IProviderProductObject
  onCreate: (product: IProviderProductObject) => any
  canSave: boolean
}

interface IFormState {
  product: IProviderProductObject
}

// TODO: consider refactoring since this very closely resembles
// the provider controls
const ProductControls = (props: IControlsProps) => {
  const { product, onCreate, canSave } = props
  const btnText = product.saving ? 'Saving...' : 'Save'
  return (
    <div className='flex absolute bottom-0 flex items-center justify-end bg-light-grey7 px2 py1 w100 z1'>
      <div className='mr3'>
        {canSave ? (
          <button className='custom-btn mbsc-green-btn' disabled={product.saving} onClick={onCreate(product)}>
            {btnText}
          </button>
        ) : (
          <button className='btn bg-light-grey rounded font-grey' disabled={true}>
            Save
          </button>
        )}
      </div>
    </div>
  )
}

class ProviderProductCreate extends FormComponent {
  constructor(props: ICreateProps) {
    super(props)

    this.state = {
      product: {
        id: null,
        organizationId: this.props.organizationId,
        integrationId: '',
        name: '',
        internalName: '',
        externalUrl: '',
        description: '',
        serviceLevel: {},
        serviceLevelId: '',
        bookingPriority: '',
        pricing: {
          basePrice: '0',
          perMilePrice: '0',
          perMinutePrice: '0',
          surcharges: '0',
          cancellationPrice: '0',
          noShowPrice: '0',
          surgeMultiple: '0',
          federalTax: '0',
          stateTax: '0'
        }
      }
    }
  }

  public render() {
    const { product } = this.state
    const { serviceLevels } = this.props

    const serviceLevelOptions = Object.keys(serviceLevels).map(id => {
      return {
        value: id,
        text: serviceLevels[id].name
      }
    })

    const bookingPriorityOptions = [
      {
        value: 'low',
        text: 'Low'
      },
      {
        value: 'high',
        text: 'High'
      }
    ]

    return (
      <div className='ProviderProductCreate'>
        <div className='form-title-header'>
          <div className='py1'>
            <span className='h3'>Create New Product</span>
          </div>
        </div>
        <FloatingForm fullHeight={true}>
          <>
            <div className='form-modal-section full-section'>
              <div className='mb2 pr2'>
                <Input
                  ref={this.attachRef('name')}
                  validate={isNotBlank}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChange(e, 'name')}
                  label={'Product Name'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
              </div>
              <div className='mb2 pr2'>
                <Input
                  ref={this.attachRef('internalName')}
                  validate={isNotBlank}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChange(e, 'internalName')}
                  label={'Internal Name'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
              </div>
              <div className='mb2 pr2'>
                <Textarea
                  ref={this.attachRef('description')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChange(e, 'description')}
                  label={'Product Description'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
              </div>
              <div className='mb2 pr2'>
                <Input
                  ref={this.attachRef('externalUrl')}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.onChange(e, 'externalUrl')}
                  label={'External URL'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
              </div>
              <div className='mb2 pr2'>
                <Select
                  name='serviceLevel'
                  onChange={this.onSelectChange('serviceLevel')}
                  data={serviceLevelOptions}
                  touchUi={false}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  label='Service Level'
                  labelStyle='floating'
                />
              </div>
              <div className='mb2 pr2'>
                <Select
                  name='bookingPriority'
                  onChange={this.onSelectChange('bookingPriority')}
                  data={bookingPriorityOptions}
                  touchUi={false}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  label='Priority'
                  labelStyle='floating'
                />
              </div>
            </div>
          </>
        </FloatingForm>
        <ProductControls product={product} canSave={true} onCreate={this.onCreate} />
      </div>
    )
  }

  private onSelectChange = (field: string) => {
    return (val: any) => {
      const p = this.state.product
      const update = { [field]: val }
      if (field === 'serviceLevel') {
        update.serviceLevelId = val.value
        update.serviceLevel = {
          value: val.value,
          label: val.valueText
        }
      } else if (field === 'bookingPriority') {
        update.bookingPriority = val.value
      }
      this.setState({ product: Object.assign(p, update) })
    }
  }

  private onChange = (event: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const p = this.state.product
    const update = { [field]: event.target.value }
    this.setState({ product: Object.assign(p, update) })
  }

  private onCreate = (product: IProviderProductObject) => {
    const { notification } = this.props
    //Make sure organization Id is set if there was a race condition before
    product.organizationId = this.props.organizationId

    const handler = this.props.onCreate(product)
    return (e: any) => {
      const product = this.state.product
      product.saving = true
      this.setState({ product }, () => {
        // Call original handler
        handler(e)
        notification.addNotification({
          title: 'Success',
          message: 'Product Created Successfully',
          level: 'success'
        })
        this.props.history.push(`/products`)
      })
    }
  }
}

export default withNotification(ProviderProductCreate)



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductCreate.tsx